<template>
  <div class="uheader">
    <img class="logo" src="../../images/ucenter/uc_vip_bg.png" alt="">
    <div class="user-box">
      <img class="user-icon" :src="info.userAvtarUrl" alt="">
      <div class="user-info">
        <p class="user-name">{{ info.nickName }}</p>
        <p v-if="!isExpired" class="user-expired">{{validTime}}</p>
        <p v-else class="user-expired" @click="buy">立即增订></p>
      </div>
    </div>
    <img class="arc-bottom" src="../../images/ucenter/uc_bottom_bg.png" alt="">
  </div>
</template>

<script>
import { strToDate } from '@/utils';

export default {
  name: 'UserCenterHeader',
  props: {
    info: {},
    membership: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      validTime: ''
    }
  },
  methods: {
    buy() {
      // 传到父组件
      this.$emit('renew')
    }
  },
  computed: {
    isExpired() {
      if (this.membership.length <= 0) {
        return false
      }
      const obj = this.membership[0]
      if (obj.endTime === undefined) {
        return false
      }
      // 2021-12-31T15:59:59.000+0000
      const endTime = strToDate(obj.endTime)
      const date = new Date(endTime)
      const time = date.getFullYear() + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + ('0' + date.getDate()).slice(-2)
      this.validTime = '增订有效期：' + time

      // 已过期(增订版会提前 30(动态的) 天提示过期)
      if (obj.status === 2) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.uheader {
  display: flex;
  justify-content: center;
  .logo {
    position: absolute;
    bottom: 5px;
    width: 82%;
    left: 9%;
  }
  .user-box {
    position: absolute;
    left: 1.22rem;
    bottom: 0.9rem;
    height: .76rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .user-icon {
      // 正方形 以rem为单位 安卓下渲染出来的正方形被拉成长方形
      // 解决:先放大一些,在 scale 回原来的比例
      width: .7rem;
      height: 1rem;
      margin-right: 0.26rem;
      border-radius: 50%;
      transform: scale(1, 0.7);
    }
    .user-info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .user-name {
        font-family: PingFangSC-Medium;
        font-size: .28rem;
        line-height: .4rem;
        color: #FFD7A4;
        background-color: #0000;
        margin-bottom: .02rem;
      }
      .user-expired {
        font-family: PingFangSC-Regular;
        font-size: .24rem;
        color: #FFD7A4;
        background-color: #0000;
      }
    }
  }
  .arc-bottom {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: -1px;
  }
}
</style>
